import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  flightDetails: {
    display: 'flex',
    flexFlow: 'row wrap',
    '& .title-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 8,
      paddingBottom: 16,
      width: '100%',
      [Theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        gap: 24,

        '& :nth-child(3)': {
          flex: 1,
        },
      },

      '& button': {
        '& span': {
          textDecoration: 'underline',
        },
        '&:hover': {
          background: 'none',
        },
      },
    },
    '& img': {
      width: 24,
      [Theme.breakpoints.up('md')]: {
        width: 32,
      },
    },
    '& h6': {
      margin: 0,
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[2],
      color: Theme.palette.primary.main,
      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[3],
      },
    },

    '& p': {
      color: Theme.palette.gray[750],
      fontSize: Theme.typography.size[1],
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[2],
      },
    },

    '& button': {
      color: Theme.palette.primary.light,
      padding: 0,
      fontSize: Theme.typography.size[2],
      width: 'auto',
    },

    '& .head-block': {
      color: Theme.palette.text.body,
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[2],
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[3],
      },
    },
    '& .layoverDaysReview': {
      fontSize: 'smaller',
      position: 'relative',
      top: '-5px',
    },

    '& .left-block, .right-block': {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      boxSizing: 'border-box',
      flex: '1 100%',
      [Theme.breakpoints.up('md')]: {
        flex: '1 50%',
      },

      '& .details': {
        display: 'flex',
        gap: 8,
        flexWrap: 'wrap',
        paddingBottom: 8,

        '& span': {
          display: 'flex',
        },
      },
    },

    '& .left-block': {
      [Theme.breakpoints.up('md')]: {
        paddingLeft: 56,
      },
    },
    '& .right-block': {
      [Theme.breakpoints.up('md')]: {
        paddingLeft: 40,
      },
    },
  },
}));

export default useStyles;
